import { InsuranceCardActions } from '../actions/InsuranceCardActions';
import { InsuranceCardFetchActions } from '../actions/InsuranceCardFetch';
import { InsuranceCardLightBoxActions } from '../actions/InsuranceCardLightBoxActions';
import { PatientActions } from '../actions/PatientActions';
import { NewSubpatientFormActions } from '../components/NewSubpatientForm/NewSubpatientFormActions';
const locale = require('browser-locale');

const initialState = {
    subpatientCreationSuccess: false,
    subpatients: [],
    mainPatientId: -1,
    showInsuranceCardLightBox: false,
};

function getLocale() {
    if (typeof window !== 'undefined') {
        return locale();
    }
    return 'en';
}

function sortAndMapSubPatients(subPatients) {
    const sortedList = subPatients.sort((subPatientA, subPatientB) => {
        const nameA = `${subPatientA.first_name} ${subPatientA.last_name}`;
        const nameB = `${subPatientB.first_name} ${subPatientB.last_name}`;
        return nameA.localeCompare(nameB, getLocale(), { sensitivity: 'base' });
    });

    return sortedList.map((subPatient) => ({
        firstName: subPatient.first_name,
        lastName: subPatient.last_name,
        patientId: subPatient.patient_id,
    }));
}

export const patientReducer = (state = initialState, action) => {
    switch (action.type) {
        case PatientActions.PATIENT_RETRIEVED: {
            const newState = {
                ...state,
                ...action.payload,
                mainPatientId: action.payload.patient_id,
                patientId: action.payload.patient_id,
                patientFirstName: action.payload.first_name,
                patientLastName: action.payload.last_name,
                mainPatientFirstName: action.payload.first_name,
                mainPatientLastName: action.payload.last_name,
                patientDateOfBirth: action.payload.date_of_birth,
                subpatients: sortAndMapSubPatients(action.payload.subpatients),
            };

            return newState;
        }

        case InsuranceCardActions.SELECTED:
            return {
                ...state,
                selectedInsuranceCard: action.payload,
            };

        case InsuranceCardFetchActions.SUCCESS:
        case InsuranceCardFetchActions.SCANNED_CARD_SUCCESS:
            return {
                ...state,
                insuranceCards: action.payload.cards,
                insuranceCardsPatient: action.payload.patientId,
            };

        case InsuranceCardLightBoxActions.OPEN:
        case InsuranceCardLightBoxActions.CLOSE:
            return {
                ...state,
                showInsuranceCardLightBox: action.payload,
            };

        case NewSubpatientFormActions.SUBPATIENT_CREATION_SUCCESS: {
            state.subpatients.push({
                firstName: action.firstName,
                lastName: action.lastName,
                patientId: action.patientId,
            });
            return {
                ...state,
            };
        }

        default:
            return state;
    }
};
